var plusDefault = "https://shopfront-cdn.tekoapis.com/static/1cbd090c04c530bc.svg";

export { plusDefault as default };
